var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"year-nav-wrap",attrs:{"id":"year-nav-wrap"}},[_c('div',{staticClass:"decades"},_vm._l((6),function(i){return _c('div',{key:i,staticClass:"decade"},[_c('div',{staticClass:"decade-label",class:{
          'curr-decade': _vm.period === (i - 1) * 10 + 1970,
          'prev-decade': _vm.period > (i - 1) * 10 + 1970,
        },attrs:{"data-decade":`${1970 + (i - 1) * 10}`},on:{"click":() => _vm.click(1970 + (i - 1) * 10)}},[_c('span',[_vm._v(_vm._s(`${1970 + (i - 1) * 10}s`))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }